import "./Helper.css";
import { helpSections } from "./Helperdata";

const Helper = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="help-page">
      {/* Sidebar */}
      <aside className="help-sidebar">
        <div className="sidebar-header">
          <h2 className="help-sidebar-head">Quant Kubera User Guide</h2>
        </div>

        <nav className="sidebar-nav">
          {helpSections.map((section) => (
            <a className="sidebar-tag" key={section.id} href={`#${section.id}`}>
              {section.title}
            </a>
          ))}
        </nav>

        {/* <a
          href="/quant-kubera-user-guide.pdf"
          download
          className="download-btn"
        >
          Download PDF
        </a> */}
      </aside>

      {/* Main Content */}
      <main className="help-content">
        {/* Hero */}
        <section className="help-hero">
          <h1>Quant Kubera User Guide</h1>

          <p>
            Learn how to use Dashboard, Live Trend, EOD Trend, Stock Detail,
            Watchlist, Option Chain, Max Pain, One Stock and Kubera AI
            Assistant.
          </p>
        </section>

        {/* Sections */}
        {helpSections.map((section) => (
          <section id={section.id} key={section.id} className="guide-section">
            {/* Header */}
            <div className="section-header">
              <div>
                <div className="header-scroll">
                  <h2 className="help-title">{section.title}</h2>
                  <button className="scroll-top-btn " onClick={scrollToTop}>
                    ↑
                  </button>
                </div>

                <p className="help-purpose">{section.purpose}</p>
              </div>
            </div>

            {/* Multiple Images */}
            {/* {section.images?.length > 0 && (
              <div className="image-grid">
                {section.images.map((img, index) => (
                  <div key={index} className="image-card">
                    <h3>{img.title}</h3>

                    <img src={img.src} alt={img.title} />

                    <p>{img.desc}</p>
                  </div>
                ))}
              </div>
            )} */}

            {/* Single Image */}
            {/* {!section.images?.length && section.image && (
              <div className="single-image-card">
                <img src={section.image} alt={section.title} />
              </div>
            )} */}

            {/* Feature Cards */}
            {/* {section.points?.length > 0 && (
              <div className="feature-grid">
                {section.points.map((point, index) => (
                  <div key={index} className="feature-card">
                    <h4>{point.title}</h4>

                    <p>{point.desc}</p>
                  </div>
                ))}
              </div>
            )} */}
            {section.heatmapColors?.length > 0 && (
              <div className="heatmap-legend">
                {section.heatmapColors.map((item, index) => (
                  <div key={index} className="heatmap-item">
                    <div
                      className="heatmap-color"
                      style={{
                        backgroundColor: item.color,
                      }}
                    />

                    <div className="heatmap-info">
                      <h4>{item.label}</h4>
                      <p>{item.meaning}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {section.points?.length > 0 && (
              <div className="feature-list-help">
                {section.points.map((point, index) => (
                  <div key={index} className="feature-row">
                    <span className="feature-title">{point.title}:</span>

                    <span className="feature-desc">{point.desc}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Tables */}
            {section.table?.length > 0 && (
              <div className="table-wrapper">
                <table className="guide-table">
                  <thead>
                    <tr>
                      <th>Feature</th>
                      <th>Description</th>
                    </tr>
                  </thead>

                  <tbody>
                    {section.table.map((row, index) => (
                      <tr key={index}>
                        <td className="feature-td">{row.label}</td>
                        <td>{row.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        ))}

        {/* Disclaimer */}
        {/* <section className="disclaimer-card">
          <h2>⚠ Disclaimer</h2>

          <p>
            Quant Kubera is an analytical platform. It does not provide
            financial advice, investment recommendations or trade execution. All
            investment decisions remain the sole responsibility of the user.
          </p>
        </section> */}
      </main>
    </div>
  );
};

export default Helper;
